import React, { useEffect, useState } from "react";
import axios from "axios";
import { ErrorMessage, Field, Form, Formik, FormikHelpers } from "formik";
import { isAuth } from "../../auth/ProtectedRoute";
import { AddUserType, RoleSelectType } from "./types/DataType";
import * as Yup from "yup";
import { ModalType } from "../../../components/modal/ModalType";
import swal from "sweetalert";
import { ActivityLogValues } from "../ActivityLog/types/DataType";

const AddUserModal = (props: ModalType) => {
  const [userRole, setUserRole] = useState<RoleSelectType[]>([]);
  const initialValues: AddUserType = {
    fullName: "",
    email: "",
    role: "",
    phone: "",
  };

  useEffect(() => {
    axios({
      method: "GET",
      url: process.env.REACT_APP_HOST_API + `role`,
      headers: {
        Authorization: `Bearer ${isAuth()}`,
      },
    })
      .then((res) => {
        setUserRole(res.data.data.data);
      })
      .catch((err) => {
        console.error(err);
        swal({
          title: "Error!",
          text: "Something went wrong. Please try again later!",
          icon: "error",
        });
      });
  }, []);
  return (
    <>
      {props.isOpen && (
        <div className="modal-overlayy">
          <div className="modal-box">
            <div className="modal-box--wrapper">
              <div className="heading">
                <h1>Add User</h1>
                <div onClick={props.toggle} style={{ cursor: "pointer" }}>
                  <svg
                    width="35"
                    height="32"
                    viewBox="0 0 35 32"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18.5995 16.0001L23.2722 11.3273C23.5763 11.0233 23.5763 10.5319 23.2722 10.228C22.9682 9.92401 22.4768 9.92401 22.1729 10.228L17.5001 14.9008L12.8274 10.228C12.5233 9.92401 12.032 9.92401 11.7281 10.228C11.424 10.5319 11.424 11.0233 11.7281 11.3273L16.4007 16.0001L11.7281 20.6729C11.424 20.9768 11.424 21.4683 11.7281 21.7722C11.8795 21.9238 12.0787 22 12.2777 22C12.4768 22 12.6758 21.9238 12.8274 21.7722L17.5001 17.0994L22.1729 21.7722C22.3245 21.9238 22.5235 22 22.7225 22C22.9216 22 23.1206 21.9238 23.2722 21.7722C23.5763 21.4683 23.5763 20.9768 23.2722 20.6729L18.5995 16.0001Z"
                      fill="black"
                      stroke="black"
                    />
                  </svg>
                </div>
              </div>
              <div className="form-wrap">
                <Formik
                  initialValues={initialValues}
                  validationSchema={Yup.object().shape({
                    fullName: Yup.string().required("This field is required"),
                    email: Yup.string()
                      .email()
                      .required("This field is required"),
                    role: Yup.string().required("This field is required"),
                    phone: Yup.number().required("This field is required"),
                  })}
                  onSubmit={(
                    values: AddUserType,
                    { setSubmitting }: FormikHelpers<AddUserType>
                  ) => {
                    const FormDetails = {
                      fullName: values.fullName,
                      email: values.email,
                      roleId: values.role,
                      phone: values.phone,
                    };
                    axios({
                      method: "POST",
                      url:
                        process.env.REACT_APP_HOST_API + `manage-invite/create`,
                      headers: {
                        Authorization: `Bearer ${isAuth()}`,
                      },
                      data: FormDetails,
                    })
                      .then((res) => {
                        console.log(res.data);
                        setSubmitting(false);
                        if (res.data.result === true) {
                          let activityLogItem;
                          if (typeof window !== "undefined") {
                            if (sessionStorage.getItem("activityDetail")) {
                              activityLogItem = JSON.parse(
                                sessionStorage.getItem("activityDetail")!
                              );
                            }
                          }
                          const activityDetail: ActivityLogValues = {
                            full_name: activityLogItem.full_name,
                            role: activityLogItem.role,
                            ip_address: activityLogItem.ip_address,
                            browser: activityLogItem.browser,
                            events: `Added new user: ${values.fullName}`,
                            module: "Admin Users",
                            location: activityLogItem.location,
                            email: activityLogItem.email,
                          };
                          axios({
                            method: "POST",
                            url:
                              process.env.REACT_APP_HOST_API +
                              "manage-activity/user",
                            headers: {
                              Authorization: `Bearer ${isAuth()}`,
                            },
                            data: activityDetail,
                          }).then(() => {
                            history.go(0);
                          });
                          swal({
                            title: "Success!",
                            text: "New User added successfully!",
                            icon: "success",
                          });
                        } else if (
                          res.data.response === false &&
                          res.data.status === 409
                        ) {
                          swal({
                            title: "Error!",
                            text: res.data.message,
                            icon: "error",
                          });
                        } else if (
                          res.data.response === false &&
                          res.data.status === 404
                        ) {
                          swal({
                            title: "Error!",
                            text: "Something went wrong. Please try again later!",
                            icon: "error",
                          });
                        }
                      })
                      .catch((err) => {
                        console.error(err);
                        swal({
                          title: "Error!",
                          text: "Something went wrong. Please try again later!",
                          icon: "error",
                        });
                      });
                  }}
                >
                  {({ isSubmitting }) => (
                    <>
                      <Form noValidate autoComplete="off">
                        <div className="form-wrap--module">
                          <div className="form-wrap--module_cell">
                            <label htmlFor="fullName">
                              Full Name(Optional)
                            </label>
                            <Field
                              id="fullName"
                              name="fullName"
                              type="text"
                              placeholder="Enter User Name"
                            />
                            <ErrorMessage name="fullName">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </div>
                          <div className="form-wrap--module_cell">
                            <label htmlFor="email">Email</label>
                            <Field
                              id="email"
                              name="email"
                              type="text"
                              placeholder="User email"
                            />
                            <ErrorMessage name="email">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </div>
                        </div>
                        <div className="form-wrap--module">
                          <div className="form-wrap--module_cell">
                            <label htmlFor="role">Select Role</label>
                            <Field
                              type="text"
                              as="select"
                              id="role"
                              name="role"
                            >
                              {userRole ? (
                                userRole.map((role: RoleSelectType) => (
                                  <>
                                    <option value="" disabled selected hidden>
                                      --Please choose an option--
                                    </option>
                                    <option value={role.id}>{role.name}</option>
                                  </>
                                ))
                              ) : (
                                <option value="" disabled>
                                  Options not available
                                </option>
                              )}
                            </Field>
                            <ErrorMessage name="role">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </div>
                          <div className="form-wrap--module_cell">
                            <label htmlFor="phone">Phone(Optional)</label>
                            <Field
                              id="phone"
                              name="phone"
                              type="text"
                              placeholder="User Phone number"
                            />
                            <ErrorMessage name="phone">
                              {(msg) => (
                                <div style={{ color: "red" }}>{msg}</div>
                              )}
                            </ErrorMessage>
                          </div>
                        </div>
                        <div className="form-wrap--bottom">
                          <div className="btns">
                            <div className="btns--wrap">
                              <button className="reset" type="reset">
                                Reset
                              </button>
                              <button type="submit" className="save">
                                {isSubmitting ? "Submitting..." : "Save"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </Form>
                    </>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AddUserModal;
